export default __webpack_public_path__ + "static/media/DentalTooth.57fa0ac0.svg";